"use client";

import { atomWithStorage } from "jotai/utils";
import { Maybe } from "../types/utility.types";

export type Settings = {
  currentProject: Maybe<string>;
};

const defaultSettings: Settings = {
  currentProject: null,
};

// Load initial settings from localStorage or use default
const initialSettings = (): Settings => {
  if (typeof window !== "undefined") {
    const storedSettings = localStorage.getItem("appSettings");
    return storedSettings ? JSON.parse(storedSettings) : defaultSettings;
  }
  return defaultSettings;
};

export const settingsAtom = atomWithStorage<Settings>(
  "appSettings",
  initialSettings()
);
